export default __webpack_public_path__ + "static/media/logo-dark-renaissance.8650b668.svg";